import axios from 'axios';


let allCardsCache = null;

const compareAlpha = (a, b) => a.name.localeCompare(b.name);

const getMonsterSubtype = (card) => {
  const desc = card.desc?.toLowerCase() || '';
  if (desc.includes('normal')) return 0;
  if (desc.includes('effect')) return 1;
  return 2;
};

const getSpellSubtypeRank = (card) => {
  const type = card.race?.toLowerCase() || '';
  if (type.includes('normal')) return 0;
  if (type.includes('quick')) return 1;
  if (type.includes('continuous')) return 2;
  return 3;
};

const getTrapSubtypeRank = (card) => {
  const type = card.race?.toLowerCase() || '';
  if (type.includes('normal')) return 0;
  if (type.includes('continuous')) return 1;
  if (type.includes('counter')) return 2;
  return 3;
};

const cardCategoryRank = (card) => {
  const type = card.type?.toLowerCase() || '';
  if (type.includes('monster') && !type.includes('fusion') && !type.includes('synchro') && !type.includes('xyz') && !type.includes('link')) return 0;
  if (type.includes('fusion')) return 1;
  if (type.includes('synchro')) return 2;
  if (type.includes('xyz')) return 3;
  if (type.includes('link')) return 4;
  if (type.includes('spell')) return 5;
  if (type.includes('trap')) return 6;
  return 99;
};

const fetchAllCards = async () => {
  if (allCardsCache) return allCardsCache;

  const url = `https://db.ygoprodeck.com/api/v7/cardinfo.php`;

  try {
    const res = await axios.get(url);
    allCardsCache = res.data.data;
    return allCardsCache;
  } catch (err) {
    console.error("Error loading all cards for description filtering:", err);
    return [];
  }
};


export const fetchCardsByName = async (searchTerm) => {
  if (!searchTerm || !searchTerm.trim()) return [];

  const lowered = searchTerm.toLowerCase();

  // 1️⃣ Name search (fast, small payload)
  const fnameUrl = `https://db.ygoprodeck.com/api/v7/cardinfo.php?fname=${encodeURIComponent(searchTerm)}`;
  let nameMatches = [];

  try {
    const res = await axios.get(fnameUrl);
    if (res.data?.data) nameMatches = res.data.data;
  } catch (err) {
    console.warn("Error fetching name matches:", err);
  }

  // 2️⃣ Load full set (only once) to search descriptions
  let descMatches = [];
  try {
    const allCards = await fetchAllCards();
    descMatches = allCards.filter(card =>
      card.desc?.toLowerCase().includes(lowered)
    );
  } catch (err) {
    console.warn("Error filtering descriptions:", err);
  }

  // 3️⃣ Merge and deduplicate
  const merged = [...nameMatches, ...descMatches];
  const unique = {};
  merged.forEach(card => { unique[card.id] = card; });
  const deduped = Object.values(unique);

  // 4️⃣ Sort
  deduped.sort((a, b) => {
    const catA = cardCategoryRank(a);
    const catB = cardCategoryRank(b);
    if (catA !== catB) return catA - catB;

    switch (catA) {
      case 0:
        if ((b.level || 0) !== (a.level || 0)) return (b.level || 0) - (a.level || 0);
        const subA = getMonsterSubtype(a);
        const subB = getMonsterSubtype(b);
        if (subA !== subB) return subA - subB;
        return compareAlpha(a, b);

      case 1:
      case 2:
        if ((b.level || 0) !== (a.level || 0)) return (b.level || 0) - (a.level || 0);
        return compareAlpha(a, b);

      case 3:
        if ((b.rank || 0) !== (a.rank || 0)) return (b.rank || 0) - (a.rank || 0);
        return compareAlpha(a, b);

      case 4:
        if ((b.linkval || 0) !== (a.linkval || 0)) return (b.linkval || 0) - (a.linkval || 0);
        return compareAlpha(a, b);

      case 5:
        const spellA = getSpellSubtypeRank(a);
        const spellB = getSpellSubtypeRank(b);
        if (spellA !== spellB) return spellA - spellB;
        return compareAlpha(a, b);

      case 6:
        const trapA = getTrapSubtypeRank(a);
        const trapB = getTrapSubtypeRank(b);
        if (trapA !== trapB) return trapA - trapB;
        return compareAlpha(a, b);

      default:
        return compareAlpha(a, b);
    }
  });

  return deduped;
};


